import PropTypes from 'prop-types';

import { SharedZoneBlocks, SharedZoneCustomSlug } from 'store/SharedZone/blocks/selectors';
import { getSharedZonePageSlug } from 'store/SharedZone/selectors';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import VoteFormWidgetLayout from 'components/VoteFormWidgetLayout';

const mapStateToProps = (state) => ({
  ...SharedZoneCustomSlug.getWidgetData(state),
  useSubscribe: SharedZoneCustomSlug.getUseSubscribeWidgetFlag(state),
  subscribeWidgetData: SharedZoneCustomSlug.getSubscribeWidgetData(state),
  isMobile: isScreenBelow800(state),
  widgetPosition: `${SharedZoneCustomSlug.getSlug(state)}_${getSharedZonePageSlug(state)}_site`,
});

const VoteFormWidget = SharedZoneBlocks.connect(mapStateToProps)(VoteFormWidgetLayout);

VoteFormWidget.propTypes = {
  /** inherit props */
  id: PropTypes.string, // required for unification 2 or more form on 1 page
  className: PropTypes.string,
  backgroundUrl: PropTypes.string,
  voting: PropTypes.shape({
    heading: PropTypes.string,
    headingTagName: PropTypes.string,
    question: PropTypes.string,
    buttonText: PropTypes.string,
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        answerId: PropTypes.string,
        answerText: PropTypes.string,
      }),
    ),
    /* redux-connected props */
    activeOptionId: PropTypes.string,
  }),
  thankYou: PropTypes.shape({
    heading: PropTypes.string,
  }),
  useSubscribe: PropTypes.bool,
  subscribeWidgetData: PropTypes.shape({
    /** inherit props */
    id: PropTypes.string, // required for unification 2 or more form on 1 page
    className: PropTypes.string,
    backgroundUrl: PropTypes.string,
    widgetPosition: PropTypes.string,
    /* virtual field passed by reduxForm */
    form: PropTypes.string, // form name for redux
    handleSubmit: PropTypes.func,
    initialize: PropTypes.func, // initialize values for the form
    /** redux-connected-props */
    isMobile: PropTypes.bool,
    /* it's named Unchecked, cause toogling starts from value - true */
    isAgreementUnchecked: PropTypes.bool,
    onSendSubscribe: PropTypes.func,
    onSubmitSubscribe: PropTypes.func,
    onEmailValidate: PropTypes.func,
    onToogleAgreement: PropTypes.func,
    requiredFieldMessage: PropTypes.string,
    emailInvalidMessage: PropTypes.string,
    initData: PropTypes.shape({
      isColumn: PropTypes.bool,
      heading: PropTypes.string,
      headingTagName: PropTypes.string,
      description: PropTypes.string,
      buttonText: PropTypes.string,
      markup: PropTypes.any,
    }),
    successData: PropTypes.shape({
      isColumn: PropTypes.bool,
      heading: PropTypes.string,
      headingTagName: PropTypes.string,
      description: PropTypes.string,
      markup: PropTypes.any,
      redirectUrl: PropTypes.string,
      buttonText: PropTypes.string,
      openInNewTab: PropTypes.bool,
    }),
    errorData: PropTypes.any,
  }),
  results: PropTypes.shape({
    message: PropTypes.string,
    totalRate: PropTypes.number,
    results: PropTypes.arrayOf(
      PropTypes.shape({
        answerId: PropTypes.string,
        rate: PropTypes.number,
      }),
    ),
  }),
};

export default VoteFormWidget;
